export const SYNC_ACTIONS = [
  "SEND_USERS",
  "SEND_MISSIONS",
  "SYNC_IAM",
  "SYNC_ERP",
  "SYNC_SALESFORCE_MISSIONS",
  "SYNC_MISSING_AVATARS",
] as const;

export type SyncAction = (typeof SYNC_ACTIONS)[number];

export type SyncTrigger = "MANUAL" | "SERVICE_ACCOUNT" | "SCHEDULED";

export type SyncRunStatus = "RUNNING" | "SUCCESS" | "FAILURE";

export interface SyncRun {
  id: string;
  action: SyncAction;
  trigger: SyncTrigger;
  triggeredBy: string;
  triggeredByName: string | null;
  status: SyncRunStatus;
  startedAt: string;
  endedAt: string | null;
  errorMessage: string | null;
}

export interface SyncActionStatus {
  action: SyncAction;
  lastRun: SyncRun | null;
  lastSuccess: SyncRun | null;
  running: boolean;
}

export interface SyncRunsPage {
  content: SyncRun[];
  totalPages: number;
  totalElements: number;
}
